/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_Step4_TitleInputs */

const et_process_step4_title = /** @type {(inputs: Process_Step4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04. Mis töötab?`)
};

const en_process_step4_title = /** @type {(inputs: Process_Step4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04. What works?`)
};

/**
* | output |
* | --- |
* | "04. What works?" |
*
* @param {Process_Step4_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_step4_title = /** @type {((inputs?: Process_Step4_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_Step4_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_step4_title(inputs)
	return en_process_step4_title(inputs)
});